import { CornerIconButton, Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer, closeDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import {
  DocumentTemplate,
  documentTemplateTypes,
  barcodeLocations,
  Reference,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import { useState } from "react";
import { FormulaireChoiceList } from "./adminFormulaires";

export function DocumentTemplateForm({
  current,
  onChange,
}: {
  current?: DocumentTemplate;
  onChange: (newValue: DocumentTemplate) => void;
}) {
  let [documentTemplate, setDocumentTemplate] = useState(
    current || ({} as DocumentTemplate)
  );
  function setNewValue(newValue: DocumentTemplate) {
    setDocumentTemplate(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid c1 gap10">
      <Input
        name={"Nom"}
        type={"text"}
        value={documentTemplate.name}
        onChange={(newValue) => {
          setNewValue({ ...documentTemplate, name: newValue });
        }}
      />

      <Input
        name={"Titre"}
        type={"textarea"}
        value={documentTemplate.title}
        onChange={(newValue) => {
          setNewValue({ ...documentTemplate, title: newValue });
        }}
      />

      <Input
        name={"Type"}
        type={"chips"}
        value={documentTemplate.type}
        options={Object.values(documentTemplateTypes).map((type) => {
          return { value: type.id, label: type.name };
        })}
        onChange={(newValue) => {
          setNewValue({ ...documentTemplate, type: newValue });
        }}
      />
      <Input
        name={"Afficher le titre"}
        type={"chips"}
        value={documentTemplate.showTitle == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({
            ...documentTemplate,
            showTitle: newValue === "true",
          });
          if (newValue === "true" && !documentTemplate.title)
            setNewValue({
              ...documentTemplate,
              title: `${documentTemplate.name}`,
            });
        }}
      />

      <Input
        name={"Afficher l'en-tête"}
        type={"chips"}
        value={documentTemplate.showHeader == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({ ...documentTemplate, showHeader: newValue === "true" });
        }}
      />
      <Input
        name={"Afficher la marge"}
        type={"chips"}
        value={documentTemplate.showLeftBar == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({
            ...documentTemplate,
            showLeftBar: newValue === "true",
          });
        }}
      />

      <Input
        name={"Afficher l'identité du patient"}
        type={"chips"}
        value={documentTemplate.showPatientIdentity == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({
            ...documentTemplate,
            showPatientIdentity: newValue === "true",
          });
        }}
      />
      <Input
        name={"Doit être validé avant impression ?"}
        type={"chips"}
        value={documentTemplate.isValidatable == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({
            ...documentTemplate,
            isValidatable: newValue === "true",
          });
        }}
      />
      <Input
        name={"Code barre"}
        type={"chips"}
        value={documentTemplate.barcodeLocation}
        options={Object.values(barcodeLocations).map((type) => {
          return { value: type.id, label: type.name };
        })}
        onChange={(newValue) => {
          setNewValue({
            ...documentTemplate,
            barcodeLocation: newValue,
          });
        }}
      />

      <Input
        name={"Code registre (Médecine légale)"}
        type={"text"}
        value={documentTemplate.registryName}
        onChange={(newValue) => {
          setNewValue({ ...documentTemplate, registryName: newValue });
        }}
      />

      <FormulairePicker
        documentTemplate={documentTemplate}
        onSelect={(newValue) => {
          setNewValue({ ...documentTemplate, reference: newValue });
        }}
      ></FormulairePicker>
      <DocumentTemplatePicker
        documentTemplate={documentTemplate.parent}
        onSelect={(newValue) => {
          setNewValue({ ...documentTemplate, parent: newValue });
        }}
      ></DocumentTemplatePicker>
    </div>
  );
}

function FormulairePicker({
  documentTemplate,
  onSelect,
}: {
  documentTemplate?: DocumentTemplate;
  onSelect: (newValue: Reference | null | undefined) => void;
}) {
  async function openReferenceChoiceDrawer() {
    await openDrawer({
      id: "referencesListDrawer",
      title: "References",

      content: (
        <FormulaireChoiceList
          onSelect={(newValue) => {
            onSelect(newValue);
            closeDrawer("referencesListDrawer");
          }}
        ></FormulaireChoiceList>
      ),
    });
  }

  return (
    <div className="field">
      <div className="label">Reference</div>
      {documentTemplate?.reference ? (
        <div
          className="card"
          onClick={() => {
            openReferenceChoiceDrawer();
          }}
        >
          <CornerIconButton
            type="delete"
            onClick={() => {
              onSelect(null);
            }}
          ></CornerIconButton>
          {documentTemplate?.reference?.name}
        </div>
      ) : (
        <div className="gray grid c1 gap10  ">
          <div className="tcenter p20">Aucun reference sélectionné</div>
          <Button
            type={"tertiary"}
            onClick={async () => {
              await openReferenceChoiceDrawer();
            }}
          >
            Choisir un reference
          </Button>
        </div>
      )}
    </div>
  );
}

function DocumentTemplatePicker({
  documentTemplate,
  onSelect,
}: {
  documentTemplate?: DocumentTemplate | null | undefined;
  onSelect: (newValue: DocumentTemplate | null | undefined) => void;
}) {
  async function openChoiceDrawer() {
    await openDrawer({
      id: "choiceListDrawer",
      title: "References",

      content: (
        <DocumentTemplatesChoiceList
          onSelect={(newValue) => {
            onSelect(newValue);
            closeDrawer("choiceListDrawer");
          }}
        ></DocumentTemplatesChoiceList>
      ),
    });
  }

  return (
    <div className="field">
      <div className="label">
        Parent (pour afficher ce document comme annexe en médecine légale)
      </div>
      {documentTemplate ? (
        <div
          className="card"
          onClick={() => {
            openChoiceDrawer();
          }}
        >
          <CornerIconButton
            type="delete"
            onClick={() => {
              onSelect(null);
            }}
          ></CornerIconButton>
          {documentTemplate?.name}
        </div>
      ) : (
        <div className="gray grid c1 gap10  ">
          <div className="tcenter p20">Aucun parent sélectionné</div>
          <Button
            type={"tertiary"}
            onClick={async () => {
              await openChoiceDrawer();
            }}
          >
            Choisir un parent
          </Button>
        </div>
      )}
    </div>
  );
}

function DocumentTemplatesChoiceList({
  onSelect,
}: {
  onSelect: (newValue: DocumentTemplate) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  return (
    <div>
      <FetchableList
        queryKey={["DocumentTemplatesChoiceList", searchKey, reload]}
        queryFn={() =>
          apiFetch("documentTemplates", "loadMany", {
            searchKey,
            types: null,
          })
        }
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue || "");
        }}
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((formulaire, index) => {
              return (
                <Card
                  key={uid()}
                  color="green"
                  onClick={async () => {
                    onSelect(formulaire);
                  }}
                >
                  <div>{formulaire.name}</div>
                </Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export async function openDocumentTemplateForm({
  current,
  onSave,
}: {
  current: DocumentTemplate;
  onSave: (newValue: DocumentTemplate) => void;
}) {
  await openDrawer({
    id: "documentTemplateDialog",
    title: "Modèle de documents",

    content: (
      <DocumentTemplateForm
        current={current}
        onChange={(newValue) => {
          current = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      if (!current) return;
      let inserted = await apiFetch("documentTemplates", "addOne", {
        documentTemplate: current,
      });
      onSave(inserted);
    },
  });
}
